import React from "react";
import { useParams } from "react-router-dom";
import RootTerms from "container/termsAndPrivacy/RootTerms";

function TermsPage(props) {
  const params = useParams();
  const { language } = params;

  return <RootTerms language={language} />;
}

export default TermsPage;
